import {  Link } from "react-router-dom"
import React, { Component } from "react";
import {Icon, Rate, Button, Row, Col, Badge} from 'antd';
import {  Button as SVAButton } from 'antd';
import { Collapse } from 'antd';
import moment from 'moment'

import '../../css/svtheme_a_custom.css'

const { Panel } = Collapse;
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;


const PtakeoffSvg = () => (
    <svg fill="currentColor" width="2em" height="2em"  viewBox="0 0 24 24" > <g>
    <path fill="none" d="M0 0h24v24H0z"/>
    <path d="M10.478 11.632L5.968 4.56l1.931-.518 6.951 6.42 5.262-1.41a1.5 1.5 0 0 1 .776 2.898L5.916 15.96l-.776-2.898.241-.065 2.467 2.445-2.626.704a1 1 0 0 1-1.133-.48L1.466 10.94l1.449-.388 2.466 2.445 5.097-1.366zM4 19h16v2H4v-2z"/>
</g></svg>
     
  );
const PtIcon = props => <Icon component={PtakeoffSvg} {...props} />

const PconnectSvg = () => (

    <svg fill="currentColor" height="1.5em" width="3em" 
         viewBox="0 0 511.999 511.999" >
    <g>
        <g>
            <path d="M506.837,276.004c-19.287-30.953-52.575-49.432-89.045-49.432H123.817l-46.843-66.481
                c-3.032-4.303-7.966-6.862-13.23-6.862H31.892c-8.938,0-16.185,7.246-16.185,16.185v55.017c0,0.043,0.002,0.086,0.002,0.129
                C6.993,224.813,0,231.941,0,240.72c0,8.938,7.246,16.185,16.185,16.185h5.066c0.21,0,2.499,6.066,2.834,6.74
                c1.171,2.353,2.506,4.623,3.998,6.787c2.895,4.197,6.43,8.001,9.876,11.748c7.096,7.718,14.811,14.894,23.293,21.074
                c4.79,3.49,9.816,6.657,15.054,9.432c17.58,9.315,37.206,14.606,57.083,15.413c1.818,0.073,3.637,0.111,5.456,0.111h58.147
                c4.033,17.483,19.716,30.56,38.406,30.56h102.248c18.69,0,34.373-13.078,38.406-30.56h101.804
                c12.397,0,23.838-6.734,29.855-17.573C513.727,299.798,513.393,286.528,506.837,276.004z M337.645,326.401H235.397
                c-3.889,0-7.053-3.165-7.053-7.053c0-3.89,3.165-7.054,7.053-7.054h102.249c3.89,0.001,7.054,3.165,7.054,7.054
                C344.699,323.236,341.535,326.401,337.645,326.401z M479.41,294.926c-0.508,0.915-1.242,0.915-1.555,0.915H369.273
                c-7.192-9.652-18.692-15.916-31.628-15.916H235.397c-12.936,0-24.434,6.263-31.627,15.916h-64.925
                c-29.609,0-57.636-12.9-76.893-35.392l-5.331-6.227c4.378-2.897,7.27-7.859,7.27-13.502c0-8.812-7.047-15.964-15.81-16.165
                c0-0.041-0.003-0.083-0.003-0.124v-38.832h7.273l46.843,66.481c3.032,4.303,7.966,6.862,13.23,6.862h296.471
                c-0.122,0.802-0.205,1.616-0.205,2.453c0,8.938,7.246,16.185,16.185,16.185h34.527c1.221,0,2.406-0.147,3.55-0.402
                c5.128,4.568,9.657,9.915,13.415,15.947C479.529,293.389,479.918,294.011,479.41,294.926z"/>
        </g>
    </g>
    </svg>
  );
const PcIcon = props => <Icon component={PconnectSvg} {...props} />;

const PcnSvg = () => (
    <svg fill="currentColor" width="1.5em" height="1em"  viewBox="0 0 512 512" > <g> <path d="M74.257,266.507l-12.101,12.099l24.006,12.104l12.103,24.006l12.099-12.099l-7.027-13.935l26.012-22.383l22.09,43.814 l15.483-15.483l-14.648-48.055l8.835-7.602c0.144-0.136,0.293-0.276,0.433-0.415c6.383-6.385,6.427-16.783-0.008-23.218 c-6.581-6.581-17.298-6.385-23.634,0.424c-4.229,4.91-5.553,6.454-7.599,8.833l-48.055-14.648l-15.486,15.483l43.814,22.09 l-22.383,26.012L74.257,266.507z"/> <path d="M494.153,202.231c9.857,0,17.847-7.991,17.847-17.847V97.015c0-9.857-7.991-17.847-17.847-17.847 c-17.236,0-467.327,0-476.305,0C7.991,79.167,0,87.158,0,97.015v317.971c0,9.857,7.991,17.847,17.847,17.847 c8.794,0,458.775,0,476.305,0c9.857,0,17.847-7.991,17.847-17.847v-87.369c0-9.857-7.991-17.847-17.847-17.847 c-29.648,0-53.768-24.12-53.768-53.768C440.384,226.352,464.504,202.231,494.153,202.231z M206.051,397.139H35.695V114.863 h170.357V397.139z M476.305,343.676v53.463H241.746V114.863h234.56v53.463c-40.81,8.293-71.616,44.454-71.616,87.675 S435.496,335.383,476.305,343.676z"/> <path d="M374.494,174.845h-82.506c-9.857,0-17.847,7.991-17.847,17.847c0,9.857,7.991,17.848,17.847,17.848h82.506 c9.857,0,17.847-7.991,17.847-17.848C392.341,182.835,384.35,174.845,374.494,174.845z"/> <path d="M291.987,273.849h70.608c9.857,0,17.847-7.991,17.847-17.847s-7.991-17.847-17.847-17.847h-70.608 c-9.857,0-17.847,7.991-17.847,17.847S282.13,273.849,291.987,273.849z"/> <path d="M374.494,301.462h-82.506c-9.857,0-17.847,7.991-17.847,17.847s7.991,17.847,17.847,17.847h82.506 c9.857,0,17.847-7.991,17.847-17.847S384.35,301.462,374.494,301.462z"/> </g>
    </svg>
     
  );
const PcnIcon = props => <Icon component={PcnSvg} {...props} />

const PlSvg = () => (
    <svg fill="currentColor" height="1.5em" width="3em" version="1.1"  viewBox="-3.2 -3.2 38.40 38.40" stroke="#000000" stroke-width="0.00032"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M30.8,14.2C30.1,13.4,29,13,28,13H8.5L4.8,8.4C4.6,8.1,4.3,8,4,8H1C0.7,8,0.4,8.1,0.2,8.4C0,8.6,0,9,0,9.3l3,11 C3.2,20.7,3.6,21,4,21h6.4l-3.3,6.6c-0.2,0.3-0.1,0.7,0,1C7.3,28.8,7.7,29,8,29h4c0.3,0,0.6-0.1,0.7-0.3l6.9-7.7H28 c1.1,0,2.1-0.4,2.8-1.2c0.8-0.8,1.2-1.8,1.2-2.8S31.6,14.9,30.8,14.2z"></path> <path d="M10.4,11h8.5l-5.1-5.7C13.6,5.1,13.3,5,13,5H9C8.7,5,8.3,5.2,8.1,5.5C8,5.8,8,6.1,8.1,6.4L10.4,11z"></path> </g></svg>
)
const PlIcon = props => <Icon component={PlSvg} {...props} />


const PsSvg = () => (
    <svg fill="currentColor" height="1.5em" width="3em" version="1.1"  viewBox="0 0 493.422 493.422" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M489.321,205.026c-5.827-6.71-16.944-7.509-23.638-1.698l-39.919,34.55l-80.896-13.097 c-4.043-9.61-9.348-19.218-15.759-28.258l43.961-12.925c3.9-1.145,6.649-4.855,6.412-9.087c-0.285-4.935-4.516-8.701-9.444-8.424 l-63.556,3.607c-0.553,0.04-1.122,0.197-1.706,0.293c-12.428-10.446-26.64-18.159-41.925-21.491l-7.153-52.481 c-0.537-3.941-3.648-7.209-7.769-7.77c-0.016,0-0.016,0-0.032,0c-4.974-0.679-9.553,2.795-10.232,7.77l-7.153,52.481 c-15.302,3.339-29.529,11.061-41.972,21.523c-0.553-0.095-1.074-0.292-1.657-0.325l-63.559-3.607 c-4.059-0.229-7.896,2.345-9.095,6.403c-1.389,4.744,1.326,9.711,6.063,11.108l43.962,12.925 c-6.411,9.048-11.732,18.665-15.775,28.281l-80.802,13.138l-39.997-34.613c-6.68-5.811-17.78-5.037-23.655,1.714 c-5.102,5.905-5.464,14.456-0.443,21.341l47.279,54.715c3.331,3.884,7.942,6.466,12.979,7.272l88.096,14.267 c16.739,25.131,48.999,42.777,86.66,45.02v8.55c-4.722,2.811-8.053,7.753-8.068,13.659l-0.032,19.202 c-0.015,8.931,7.216,16.178,16.139,16.194c0.016,0,0.016,0,0.03,0c8.923,0,16.156-7.225,16.17-16.145l0.032-19.202 c0.016-5.93-3.332-10.905-8.101-13.723v-8.534c37.661-2.243,69.921-19.889,86.66-45.028l88.082-14.258 c5.053-0.805,9.663-3.388,12.963-7.241l47.751-55.299C494.799,219.498,494.437,210.947,489.321,205.026z M66.413,272.405 c-1.279-0.205-2.431-0.852-3.3-1.856l-46.014-54.998l45.309,39.128l27.502-4.419l5.669,26.868L66.413,272.405z M112.679,279.899 l-6.773-32.167l36.807-5.811c-1.926,7.485-3.063,14.773-3.063,21.507c0,7.414,1.342,14.567,3.616,21.42L112.679,279.899z M246.68,323.725c-17.339,0-33.397-3.931-46.709-10.596c30.509-7.437,62.911-7.437,93.419,0 C280.077,319.794,264.018,323.725,246.68,323.725z M310.786,301.09c-40.482-12.56-86.349-13.777-128.21,0.002 c-11.49-10.358-18.67-23.348-18.67-37.664c0-34.898,38.688-92.628,82.774-92.628c44.088,0,82.776,57.73,82.776,92.628 C329.456,277.743,322.275,290.733,310.786,301.09z M380.68,279.899l-30.587,4.95c2.273-6.853,3.617-14.006,3.617-21.42 c0-6.68-1.106-13.902-3.017-21.316l36.699,5.936L380.68,279.899z M430.216,270.582c-0.838,0.972-1.989,1.619-3.284,1.824 l-29.15,4.722l5.589-26.498l27.326,4.364l46.86-39.19L430.216,270.582z"></path> <path d="M210.108,236.837h73.112c6.694,0,12.127-5.433,12.127-12.128c0-6.696-5.433-12.127-12.127-12.127h-73.112 c-6.696,0-12.127,5.432-12.127,12.127C197.981,231.404,203.413,236.837,210.108,236.837z"></path> </g> </g>
    </svg>)
const PsIcon = props => <Icon component={PsSvg} {...props} />

const PstopSvg = () => (
    <svg fill="currentColor" height="1.5em" width="1.5em" viewBox="0 0 496 496"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M496,248c0-40.24-24.92-74.728-60.112-88.976c-9.2-19.4-21.216-36.904-35.408-52.192l33.496-33.496 C440.304,77.528,447.864,80,456,80c22.056,0,40-17.944,40-40c0-22.056-17.944-40-40-40c-22.056,0-40,17.944-40,40 c0,8.136,2.472,15.696,6.664,22.024L389.16,95.528C351.352,60.6,301.224,40,248,40S144.648,60.6,106.84,95.528L73.336,62.024 C77.528,55.696,80,48.136,80,40C80,17.944,62.056,0,40,0C17.944,0,0,17.944,0,40c0,22.056,17.944,40,40,40 c8.136,0,15.696-2.472,22.024-6.664l33.496,33.496c-14.192,15.288-26.208,32.8-35.408,52.192C24.92,173.272,0,207.76,0,248 s24.92,74.728,60.112,88.976c9.2,19.4,21.216,36.904,35.408,52.192l-33.496,33.496C55.696,418.472,48.136,416,40,416 c-22.056,0-40,17.944-40,40c0,22.056,17.944,40,40,40c22.056,0,40-17.944,40-40c0-8.136-2.472-15.696-6.664-22.024l33.504-33.504 C144.648,435.4,194.776,456,248,456s103.352-20.6,141.16-55.528l33.504,33.504C418.472,440.304,416,447.864,416,456 c0,22.056,17.944,40,40,40c22.056,0,40-17.944,40-40c0-22.056-17.944-40-40-40c-8.136,0-15.696,2.472-22.024,6.664l-33.496-33.496 c14.192-15.296,26.208-32.8,35.408-52.192C471.08,322.728,496,288.24,496,248z M456,16c13.232,0,24,10.768,24,24s-10.768,24-24,24 s-24-10.768-24-24S442.768,16,456,16z M40,64c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S53.232,64,40,64z M40,480c-13.232,0-24-10.768-24-24s10.768-24,24-24s24,10.768,24,24S53.232,480,40,480z M456,432c13.232,0,24,10.768,24,24 s-10.768,24-24,24s-24-10.768-24-24S442.768,432,456,432z M414.88,153.272c-4.864-0.76-9.808-1.272-14.88-1.272h-43.272 c22.112-7.64,35.912-16.2,42.992-21.448C405.272,137.704,410.336,145.296,414.88,153.272z M389.304,118.28 c-7.8,5.536-25.128,15.712-54.4,23.472c-19.296-39.448-45.32-67.832-62.936-84.136C317.288,63.352,358.8,85.136,389.304,118.28z M256,64.856c15.704,13.864,42.848,41.464,62.824,80.624c-17.416,3.48-38.28,5.888-62.824,6.344V64.856z M240,64.856v86.968 c-24.544-0.456-45.408-2.864-62.824-6.344C197.152,106.312,224.296,78.72,240,64.856z M224.032,57.608 c-17.616,16.304-43.64,44.696-62.936,84.136c-29.272-7.752-46.6-17.928-54.4-23.472C137.2,85.136,178.712,63.352,224.032,57.608z M96.28,130.552c7.08,5.248,20.888,13.808,42.992,21.448H96c-5.072,0-10.016,0.512-14.872,1.272 C85.664,145.296,90.728,137.704,96.28,130.552z M16,248c0-44.112,35.888-80,80-80h144h16c44.112,0,80,35.888,80,80 c0,14.168-3.88,27.848-10.928,40h-29.96C305.52,277.824,312,263.664,312,248c0-30.88-25.128-56-56-56H96c-30.872,0-56,25.12-56,56 s25.128,56,56,56h66.184c6.792,9.408,15.184,17.576,24.864,24H96C51.888,328,16,292.112,16,248z M256,288h-16 c-22.056,0-40-17.944-40-40c0-22.056,17.944-40,40-40h16c22.056,0,40,17.944,40,40C296,270.056,278.056,288,256,288z M152.84,288 H96c-22.056,0-40-17.944-40-40c0-22.056,17.944-40,40-40h56.72c-5.728,12.48-8.72,26.08-8.72,40 C144,262.288,147.224,275.808,152.84,288z M81.12,342.728C85.984,343.488,90.928,344,96,344h43.272 c-22.112,7.64-35.912,16.2-42.992,21.448C90.728,358.296,85.664,350.704,81.12,342.728z M106.696,377.72 c7.8-5.536,25.128-15.712,54.4-23.472c19.296,39.448,45.32,67.832,62.936,84.136C178.712,432.648,137.2,410.864,106.696,377.72z M240,431.144c-15.704-13.864-42.848-41.464-62.824-80.624c17.416-3.48,38.28-5.888,62.824-6.344V431.144z M240,328 c-44.112,0-80-35.888-80-80c0-14.168,3.88-27.848,10.928-40h29.96C190.48,218.176,184,232.336,184,248c0,30.88,25.128,56,56,56 h160c30.872,0,56-25.12,56-56s-25.128-56-56-56h-66.184c-6.792-9.408-15.184-17.576-24.864-24H400c44.112,0,80,35.888,80,80 s-35.888,80-80,80H256H240z M343.16,208H400c22.056,0,40,17.944,40,40c0,22.056-17.944,40-40,40h-56.72 c5.728-12.48,8.72-26.08,8.72-40C352,233.712,348.776,220.192,343.16,208z M256,431.144v-86.968 c24.544,0.456,45.408,2.864,62.824,6.344C298.848,389.688,271.704,417.28,256,431.144z M271.968,438.392 c17.616-16.304,43.64-44.696,62.936-84.136c29.272,7.752,46.6,17.928,54.4,23.472C358.8,410.864,317.288,432.648,271.968,438.392z M399.72,365.448c-7.08-5.248-20.888-13.808-42.992-21.448H400c5.072,0,10.016-0.512,14.872-1.272 C410.336,350.704,405.272,358.296,399.72,365.448z"></path> </g> </g> </g></svg>)
const PstopIcon = props => <Icon component={PstopSvg} {...props} />



const PmcitySvg = () => (
    <svg fill="currentColor" width="2em" height="2em"  viewBox="0 0 43.491 43.491" > <g>
   <g>
		<path d="M41.625,9.778c-0.378-0.23-3.22-1.961-3.22-1.961s2.054-5.874,1.875-6.688C40.104,0.316,39.232,0,39.232,0l-3.461,6.388
			l-3.557-1.546l-0.021-2.333l-1.087-0.966c0,0-0.317,2.663-0.77,3.308c-0.449,0.644-2.229,1.851-2.229,1.851l0.938,0.95
			l2.426-1.307l2.991,2.071l-3.716,6.216c0,0,0.749,0.923,1.486,0.521c0.736-0.402,4.342-5.037,4.342-5.037s3.501,1.958,3.873,2.043
			c0.372,0.087,1.291,0.574,1.757-0.54C42.67,10.506,42.003,10.008,41.625,9.778z"/>
		<path d="M36.078,16.177c-0.525-0.631-1.115-1.204-1.732-1.745l-0.899,0.93c0.565,0.492,1.108,1.013,1.592,1.587
			c-0.875,0.573-1.894,1.078-3.024,1.496c-0.832-2.472-2.047-4.528-3.511-5.924c0.554,0.181,1.089,0.401,1.609,0.646l0.688-1.107
			c-2.05-0.985-4.346-1.539-6.768-1.539c-0.01,0-0.016,0-0.021,0s-0.011,0-0.016,0c-0.018,0-0.035,0.002-0.055,0.002
			c-4.798,0.028-9.092,2.224-11.951,5.654c-0.264,0.317-0.514,0.645-0.752,0.982c-1.813,2.557-2.882,5.674-2.882,9.04
			c0,3.365,1.069,6.482,2.882,9.04c0.238,0.337,0.488,0.666,0.752,0.981c2.86,3.431,7.153,5.625,11.951,5.653
			c0.02,0,0.037,0.002,0.055,0.002c0.005,0,0.01,0,0.016,0s0.014,0,0.021,0c4.836,0,9.167-2.202,12.045-5.655
			c0.264-0.316,0.514-0.646,0.752-0.982c1.812-2.557,2.881-5.676,2.881-9.04c0-3.365-1.068-6.483-2.881-9.04
			C36.592,16.822,36.344,16.493,36.078,16.177z M19.451,12.56c-1.441,1.39-2.638,3.422-3.463,5.861
			c-1.106-0.413-2.102-0.91-2.959-1.473C14.712,14.951,16.924,13.412,19.451,12.56z M12.274,17.932
			c0.974,0.651,2.101,1.22,3.347,1.689c-0.537,1.964-0.846,4.145-0.856,6.446H9.646C9.675,23.04,10.647,20.24,12.274,17.932z
			 M9.693,27.354h5.096c0.083,1.926,0.375,3.752,0.832,5.424c-1.246,0.469-2.373,1.039-3.347,1.689
			C10.832,32.421,9.904,29.988,9.693,27.354z M13.033,35.447c0.857-0.561,1.85-1.057,2.953-1.469
			c0.826,2.438,2.023,4.47,3.465,5.859C16.924,38.986,14.716,37.445,13.033,35.447z M23.391,40.543
			c-2.639-0.361-4.917-3.068-6.209-6.967c1.862-0.559,3.971-0.896,6.209-0.952V40.543z M23.391,31.339
			c-2.36,0.058-4.587,0.423-6.568,1.03c-0.406-1.542-0.666-3.232-0.745-5.016h7.313V31.339z M23.391,26.066h-7.339
			c0.011-2.16,0.292-4.201,0.776-6.036c1.979,0.606,4.204,0.972,6.563,1.028V26.066L23.391,26.066z M23.391,19.773
			c-2.237-0.055-4.346-0.392-6.207-0.95c1.293-3.896,3.568-6.607,6.207-6.969V19.773z M24.678,11.864
			c2.61,0.403,4.858,3.108,6.137,6.979c-1.844,0.546-3.926,0.877-6.137,0.931V11.864z M24.678,21.059
			c2.332-0.056,4.53-0.413,6.494-1.007c0.479,1.829,0.76,3.863,0.77,6.015h-7.264V21.059z M24.678,27.354h7.238
			c-0.078,1.774-0.337,3.457-0.738,4.994c-1.965-0.595-4.168-0.953-6.5-1.009V27.354z M24.678,40.534v-7.909
			c2.211,0.055,4.295,0.385,6.141,0.932C29.539,37.428,27.288,40.13,24.678,40.534z M28.502,39.876
			c1.463-1.396,2.682-3.45,3.514-5.922c1.129,0.417,2.146,0.921,3.021,1.493C33.327,37.475,31.077,39.033,28.502,39.876z
			 M35.794,34.467c-0.991-0.664-2.144-1.242-3.416-1.716c0.452-1.664,0.742-3.481,0.824-5.397h5.173
			C38.164,29.988,37.236,32.421,35.794,34.467z M33.229,26.066c-0.012-2.291-0.317-4.462-0.852-6.42
			c1.273-0.474,2.424-1.052,3.415-1.714c1.626,2.308,2.601,5.108,2.628,8.134H33.229z"/>
		<path d="M3.69,25.822c0-11.465,9.327-20.794,20.794-20.794c1.187,0,2.344,0.117,3.475,0.31l1.316-0.811l0.434-1.44
			c-1.486-0.3-3.65-0.622-5.225-0.622c-12.88,0-23.357,10.479-23.357,23.357c0,1.355,0.069,2.625,0.222,3.83
			c0.641,5.061,7.079,13.838,12.19,13.839C8.005,39.533,3.69,33.273,3.69,25.822z"/>
	</g></g></svg>
     
  );
const PmcityIcon = props => <Icon component={PmcitySvg} {...props} />

class AmbLocationSVPriceListView extends Component {
  
    portDetails =(dcityName,dstateCode,dcountryCode, sum_org, ocityName,ostateCode,ocountryCode,sum_dst)=>{
        return (<span style={{fontSize: "14px"}} className="d-block" >   <text style={{fontSize:'14px', color:'rgb(61, 10, 204)'}} className="svr-hotel-room " >{ocityName}, {ostateCode},{ocountryCode} ({sum_org})  </text><PcIcon  style={{ fontSize:'18px', color: 'rgb(61, 10, 204)' }} type="export"  /> <text style={{fontSize:'14px', color: 'rgb(61, 10, 204)'}} className="svr-hotel-room" >{dcityName}, {dstateCode}, {dcountryCode} ({sum_dst}) </text> </span>)
        
    }
    portMDetails =(sum_org,sum_dst, pmap)=>{
        let {ocityName ,ostateCode,ocountryCode,oairportName,dcityName ,dstateCode,dcountryCode,dairportName} = {
            "ocityName": "CATA",
            "ocityCode": "",
            "ocountryCode":"",
            "oairportName": "",
            "dcityName": "",
            "dcityCode": "",
            "dcountryCode":"",
            
            "dairportName":""
            
          }
         let oad = pmap[sum_org] ? pmap[sum_org]  : {}
         ocityName = oad.city ? oad.city : ''
         oairportName = oad.name ? oad.name : ''

         let dad = pmap[sum_dst] ? pmap[sum_dst]  :{}
         dcityName = dad.city ? dad.city :''
         dairportName = dad.name ? dad.name : ''

        return (<span style={{fontSize: "14px"}} className="d-block" >   <text style={{fontSize:'14px', color:'#e82c8d'}} className="svr-hotel-room " >{ocityName}, ({sum_org})  </text><PcIcon  style={{ fontSize:'18px', color: '#e82c8d' }} type="import"  /> <text style={{fontSize:'14px',color:'#e82c8d'}} className="svr-hotel-room" >{dcityName}, ({sum_dst})</text> </span>)

        
    }
    constructor(props) {
        super(props)
        let me = this
        this.mp = new Object()
        this.mp['133'] = 'Destionation'
        this.depDis = this.depDis.bind(me)
        this.dayDis = this.dayDis.bind(me)
        this.timeDis = this.timeDis.bind(me)
        this.hdrDayDis = this.hdrDayDis.bind(me)
        this.detDis = this.detDis.bind(me)
        this.layoverDis = this.layoverDis.bind(me)

        this.portDetails = this.portDetails.bind(me)
        this.portMDetails = this.portMDetails.bind(me)
        

        this.fltTime = this.fltTime.bind(me)
        this.reloadReviewPageSV = this.reloadReviewPageSV.bind(me)
        this.reloadMyFlyReservationReviewPageSV = this.reloadMyFlyReservationReviewPageSV.bind(me)
        this.getPanelHdr = this.getPanelHdr.bind(this)
        this.getPanelBody = this.getPanelBody.bind(this)
        this.getFSKReserveHtmlButton = this.getFSKReserveHtmlButton.bind(this)
        this.callbackAc = this.callbackAc.bind(this)
        this.state = {
            expandIconPosition: 'left',
          }
        
      
        this.location = {
            "resort_name": "253 Mancreek Resort",
            "address_line1": " 253 scottland av",
            "county": "albanyt",
            "postalcode": 12193,
            "market_code": "NAMER",
            "country": "usa",
            "region_desc_en": [
                "United States",
                "Coastal Mid Atlantic"
            ],
            "state": "NY",
        }

        this.getFSKReserveHtmlButton = this.getFSKReserveHtmlButton.bind(this)
        //this.getHotelAmenityList = this.getHotelAmenityList.bind(this)
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(this)

    }
    fltTime=(s)=>{
        s =  s ? s : 'PT10H48M'

        let t  = s.indexOf('T')
        let h = s.indexOf('H')
        let m = s.indexOf('M')

        let sh =  s.slice(t+1, h)
        let sm =  s.slice(h+1, m)

        let ds = `${sh} h ${sm} m`
        return ds 
    }

    reloadReviewPageSV=(ob )=>(e)=>{
        let me = this
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SVOCT25 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }
        me.props.svofferselectparent(cidOffer, ob.flight_space_key) 
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    reloadMyFlyReservationReviewPageSV=(masterCustOffer )=>(e)=>{
        let me = this
        let ob = masterCustOffer.o
        let svcustProfile = masterCustOffer.svcustProfile
        console.log('sv****Got the nov19  page reloadMyFlyReservationReviewPageSV needs customerId')
        console.log(ob)
        let cidOffer = null
        if(me.props.priceInfo.o){
            console.log('SV nov19 Step1 2********')
            cidOffer = me.props.priceInfo.o
            //cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
        }
        me.props.svofferMyFlyReservationSelectparent(cidOffer, ob.flight_space_key, svcustProfile) 
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
       
       console.log(this.props);
      
      
       
      console.log('sv-cook********2' )
     


    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
       
  

   
       // this.props.priceAndTexNow(id);
   
			
			
	

	}
    getPanelBody(seg, idx){
        //let sum_org = seg.
       

        let {pmap,amap} = this.props.svfly_esquery_data
        if(!amap){
            amap = {
                "B6":{
                    "name" : "JetBlue Airways",
                    "IATA" : "B6"
                },
                "UA":{
                    "name" : "United Airlines",
                    "IATA" : "UA"
                }
            }
        }
        if(!pmap){
            pmap = {
                "DCA":{
                    "airportid": 3520,
                    "altitude": 15,
                    "city": "Washington",
                    "country": "United States",
                    "datsource": "OurAirports",
                    "name": "Ronald Reagan Washington National Airport",
                    "stationType": null,
                    "svdst": "A",
                    "svtimezone": "-5",
                    "svtzDatabaseTimezone": "America/New_York",
                    "IATA": "DCA",
                    "ICAO": "KDCA",
                    "LAT": 38.8521,
                    "LNG": -77.037697
                }
            }

        }
        let sum_airlines = seg.carrierCode ? seg.carrierCode :null
        let airlinesName = ''
        if(sum_airlines && amap[sum_airlines]){
            airlinesName = amap[sum_airlines].name
        }

        let sum_org = seg.departure.iataCode
        let sum_dst = seg.arrival.iataCode
        let {ocityName ,ostateCode,ocountryCode,oairportName,dcityName ,dstateCode,dcountryCode,dairportName} = {
            "ocityName": "CATA",
            "ocityCode": "",
            "ocountryCode":"",
            "oairportName": "",
            "dcityName": "",
            "dcityCode": "",
            "dcountryCode":"",
            
            "dairportName":""
            
          }
         let oad = pmap[sum_org] ? pmap[sum_org]  : {}
         ocityName = oad.city ? oad.city : ''
         oairportName = oad.name ? oad.name : ''

         let dad = pmap[sum_dst] ? pmap[sum_dst]  :{}
         dcityName = dad.city ? dad.city :''
         dairportName = dad.name ? dad.name : ''

        return (
            <div className="o-container-flist">
            <div className="o-box-flist-b1">
                <span className="o-span">
                
                        
                            
                            
                            <span>
                            <p className="m-para-text">
                            <span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(41, 199, 236)' }} type="play-circle" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>Y{this.detDis(seg.departure.at)}</text><PsIcon type="line" style={{ color: 'rgba(251, 135, 12, 0.93)' }}  /><text  style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>{this.detDis(seg.arrival.at)}</text></span>
                                
                                <text style={{fontSize:'14px'}} className="svr-hotel-room d-block" >  {seg.carrierCode  }{seg.number  }  - Aircraft {seg.aircraft.code  } </text>
                                <span style={{fontSize: "14px"}} className="d-block" >   <text style={{fontSize:'14px', color:'rgb(61, 10, 204)'}} className="svr-hotel-room " >{ocityName} ({sum_org})  </text><PcIcon  style={{ fontSize:'18px', color: 'rgb(61, 10, 204)' }} type="export"  /> <text style={{fontSize:'14px', color: 'rgb(61, 10, 204)'}} className="svr-hotel-room" >{dcityName} ({sum_dst}) </text> </span>
                                <span style={{fontSize: "14px"}} > <PcnIcon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>{airlinesName}, Operated By {sum_airlines}</text></span>
        
                            </p>
                            </span>
                        
                    
        
                
                </span>
            </div>
            <div className="o-box-flist-b2">
                <span className="o-span">
                    
                            <p className="m-para-text">
                            <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >{this.fltTime(seg.duration) }</text><PstopIcon style={{paddingLeft: "10px", color: 'rgb(27, 181, 227)' , fontSize:'14px'}}   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >Overnight</text></span>
                                <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> {this.mp['x'+idx]} </text>
                                <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> {seg.carrierCode  }{seg.number  } </text>
                            </p>
                        
                </span>
        </div>                       
    </div>
        )
    }
    getPanelHdr(seg){
        return (<span style={{fontSize: "14px"}} > <Icon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="box-plot" theme="filled" /><text style={{color:'rgb(238, 105, 105)', fontSze:'18px',  paddingLeft: "10px", paddingRight:'20px'}} >{seg.departure.iataCode}</text><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>{this.hdrDayDis(seg.departure.at)}</text><PsIcon type="line" style={{ color: 'rgba(251, 135, 12, 0.93)' }}  /><text style={{color:'#cc8e3b', fontSze:'18px',  paddingLeft: "10px", paddingRight:'20px'}} >{seg.arrival.iataCode}</text><text  style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}}>{this.hdrDayDis(seg.arrival.at)}</text></span>
        )
    }
    onPositionChange = expandIconPosition => {
    this.setState({ expandIconPosition });
  };
    callbackAc(key){
        console.log(key);

    }
    
    getFSKReserveHtmlButton(o,svcustProfile){
        let me = this
        let customerId = -1
       
        /*
         console.log('sv******** getFSKReserveHtmlButton start ')
        console.log(o)
        console.log(svcustProfile)
        console.log('sv******** getFSKReserveHtmlButton end')
onClick={me.reloadReviewPageSV(o).bind(this)}
        */
        if(!svcustProfile){
            return( <SVAButton onClick={me.reloadReviewPageSV(o).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >Fly Reserve </SVAButton>
            )
           
        }
        if(typeof(svcustProfile.customerId) == "string"){
            customerId = parseInt(svcustProfile.customerId )
        }else{
            customerId = svcustProfile.customerId
        }
       console.log("customerId:", customerId)
        if(customerId > 0){
            let masterCustOffer = {
                "svcustProfile": svcustProfile,
                "o":o
            }
            return( <SVAButton onClick={me.reloadMyFlyReservationReviewPageSV(masterCustOffer).bind(this)}  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >MyFlightReserve </SVAButton>
            )
            /*
            return (<Button  style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myflyreservationsSV/${customerId}/flyressvCustNew/${o.flight_space_key}`}> MyFlightReserve  </Link></Button>)
            */

        }else{

            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >IReserve</Button>)
            
        }
        
    }

    getFSKReserveHtmlButton_old(o,svcustProfile){
        console.log('sv******** getFSKReserveHtmlButton start ')
        console.log(o)
        console.log(svcustProfile)
        console.log('sv******** getFSKReserveHtmlButton end')
        /*
        const { cookies } = this.props;
        if(this.props.priceInfo  ){
            console.log('SVOCT25 Step1 1************')
            console.log(this.props)
            
            if(this.props.priceInfo.o){
                console.log('SVOCT25 Step1 2********')
                cookies.set('svcook', this.props.priceInfo.o, { path: '/' });
            }
           
         }else{
            cookies.set('svcook', "ggnnxx", { path: '/' });
         }
         */
        
        let customerId = -1
        if(!svcustProfile){
            
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svflysearch/svredfly/${o.flight_space_key}`}>Fly Reserve  </Link></Button>)
            
        }
        if(typeof(svcustProfile.customerId) == "string"){
            customerId = parseInt(svcustProfile.customerId )
        }else{
            customerId = svcustProfile.customerId
        }
       console.log("customerId:", customerId)
        if(customerId > 0){
            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myflyreservationsSV/${customerId}/flyressvCustNew/${o.flight_space_key}`}> MyFlightReserve  </Link></Button>)
            

        }else{

            return (<Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svflysearch/svredfly/${o.flight_space_key}`}> IReserve  </Link></Button>)
            
        }
        
    }
    getStepBody(){
        return (<p>I am sweet</p>)
    }
   
   

    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
        console.log(param1)
		let me = ctx
		me.currentSelection = param1.sojourncode
		console.log('sv delete task curry')
		console.log(param1.sojourncode)
		//me.props.svWrappedDeleteTaskActionCreator(param1.id)
	}
   

    render() {

        /*
 let svr_fly = {
      "startdate": soj['startdate'] ? soj['startdate'] : "06:30",
                                        "enddate": soj['enddate'] ? soj['enddate'] : "7:30",
                                        "flight_arrival_daytime": soj['flight_arrival_daytime'] ? soj['flight_arrival_daytime'] : "AM",
                                        "flight_departure_daytime": soj['flight_departure_daytime'] ? soj['flight_departure_daytime'] : "PM",

                                        "origin_airport_code": soj['origin_airport_code'] ? soj['origin_airport_code'] : "SJC",
                                        "origincity": soj['origincity'] ? soj['origincity'] : "Sajn Jose",
                                        "dst_airport_code": soj['dst_airport_code'] ? soj['dst_airport_code'] : "AUS",
                                        "destcity": soj['destcity'] ? soj['destcity'] : "Austin",
                                        "airlines_name": soj['airlines_name'] ? soj['airlines_name'] : "Delta Airlines",
                                        

                                    }
        */
     let svmcity = false
     const {svcustProfile, priceInfo} = this.props
     let {svfly_esquery_data} = this.props
     if(!svfly_esquery_data) {
        svfly_esquery_data = {
            esqueryDestMob :{
                "type": "location",
                "subType": "AIRPORT",
                "name": "JOHN F KENNEDY INTL",
                "detailedName": "NEW YORK/NY/US:JOHN F KENNEDY",
                "id": "AJFK",
                
                "timeZoneOffset": "-04:00",
                "iataCode": "JFK",
                "geoCode": {
                  "latitude": 40.63973,
                  "longitude": -73.77861
                },
                "address": {
                  "cityName": "NEW YORK",
                  "cityCode": "NYC",
                  "countryName": "UNITED STATES OF AMERICA",
                  "countryCode": "US",
                  "stateCode": "NY",
                  "regionCode": "NAMER"
                },
                "analytics": {
                  "travelers": {
                    "score": 35
                  }
                }
              },
               esqueryMob :{
                   iataCode: "ORD",
                   address:  { cityName: "CHICAGO", cityCode: "CHI", countryName: "UNITED STATES OF AMERICA" },
                   detailedName: "CHICAGO/IL/US:O HARE INTERNATI",
                   geoCode:  { latitude: 41.97862, longitude: -87.90472 },
    
                },
            escountryOrg:"US",
            escountryDst:"US",
            my_orgqueryText: "xx",
            my_dstqueryText: "yy",
            STARTDATE:"2025-11-25",
            ENDDATE: "2025-11-27",
            DT_FORMAT: "%Y-%m-%d",
            time_zone: "Asia/Kolkata",
    
    
            esqueryChilds:"m0",
            esqueryInfants:"i0",
            esqueryAdults:"t1",
            esqueryCabin:"ECONOMY",
            esqueryTripType:"roundtrip",
            svpageSize:5
    
    
        }
     }
     if(svfly_esquery_data['esqueryTripType'] == 'multicity'){
        svmcity = true
     }
     let {ocityName ,ostateCode,ocountryCode,dcityName ,dstateCode,dcountryCode} = {
        "ocityName": "CATA",
        "ocityCode": "",
        "ocountryCode":"",
        "dcityName": "",
        "dcityCode": "",
        "dcountryCode":""
        
      }
     let {esqueryMob, esqueryDestMob, amap, pmap} = svfly_esquery_data
     if(!amap){
        amap = {
            "B6":{
                "name" : "JetBlue Airways",
                "IATA" : "B6"
            },
            "UA":{
                "name" : "United Airlines",
                "IATA" : "UA"
            }
        }
    }

    
    if(!pmap){
        pmap = {
            "DCA":{
                "airportid": 3520,
                "altitude": 15,
                "city": "Washington",
                "country": "United States",
                "datsource": "OurAirports",
                "name": "Ronald Reagan Washington National Airport",
                "stationType": null,
                "svdst": "A",
                "svtimezone": "-5",
                "svtzDatabaseTimezone": "America/New_York",
                "IATA": "DCA",
                "ICAO": "KDCA",
                "LAT": 38.8521,
                "LNG": -77.037697
            }
        }

    }
     let address = null
     console.log('**av**Aug26**esqueryMob***',esqueryMob )
     if(esqueryMob){
        address = esqueryMob.address
        /*
     }else{
        address = {
            cityName : '',
            stateCode :'',
            ocountryCode : ''
        }   
        */
     }
     
     
     console.log('**av**Aug26**address***',address )
     if(address){
          ocityName = address.cityName
          ostateCode = address.stateCode
          ocountryCode = address.ocountryCode
     }else{
         console.log('**av**Aug26**esqueryMob***Eroror')
     }
   
     if(esqueryDestMob && esqueryDestMob.address){
         address = esqueryDestMob.address
         dcityName = address.cityName ?address.cityName : ''
         dstateCode = address.stateCode ? address.stateCode : ''
         dcountryCode = address.countryCode ? address.countryCode :''

     }
     let offer = priceInfo.o
     console.log('sv****OCT23 priceInfo.o ', offer)
     /*
       const offer = {
        "type": "flight-offer",
        "id": "1",
        "source": "GDS",
        "instantTicketingRequired": false,
        "nonHomogeneous": false,
        "oneWay": false,
        "isUpsellOffer": false,
        "lastTicketingDate": "2024-10-24",
        "lastTicketingDateTime": "2024-10-24",
        "numberOfBookableSeats": 1,
        "itineraries": [
            {
                "duration": "PT46H34M",
                "segments": [
                    {
                        "departure": {
                            "iataCode": "EWR",
                            "terminal": "B",
                            "at": "2024-11-01T19:59:00"
                        },
                        "arrival": {
                            "iataCode": "LAX",
                            "terminal": "6",
                            "at": "2024-11-01T23:10:00"
                        },
                        "carrierCode": "AS",
                        "number": "287",
                        "aircraft": {
                            "code": "7M9"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT6H11M",
                        "id": "1",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    },
                    {
                        "departure": {
                            "iataCode": "LAX",
                            "terminal": "6",
                            "at": "2024-11-02T19:45:00"
                        },
                        "arrival": {
                            "iataCode": "ANC",
                            "terminal": "S",
                            "at": "2024-11-03T00:19:00"
                        },
                        "carrierCode": "AS",
                        "number": "193",
                        "aircraft": {
                            "code": "73H"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT5H34M",
                        "id": "2",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    },
                    {
                        "departure": {
                            "iataCode": "ANC",
                            "terminal": "S",
                            "at": "2024-11-03T13:30:00"
                        },
                        "arrival": {
                            "iataCode": "ADQ",
                            "at": "2024-11-03T14:33:00"
                        },
                        "carrierCode": "AS",
                        "number": "89",
                        "aircraft": {
                            "code": "73H"
                        },
                        "operating": {
                            "carrierCode": "AS"
                        },
                        "duration": "PT1H3M",
                        "id": "3",
                        "numberOfStops": 0,
                        "blacklistedInEU": false
                    }
                ]
            }
        ],
        "price": {
            "currency": "USD",
            "total": "1446.23",
            "base": "1324.63",
            "fees": [
                {
                    "amount": "0.00",
                    "type": "SUPPLIER"
                },
                {
                    "amount": "0.00",
                    "type": "TICKETING"
                }
            ],
            "grandTotal": "1446.23"
        },
        "pricingOptions": {
            "fareType": [
                "PUBLISHED"
            ],
            "includedCheckedBagsOnly": true
        },
        "validatingAirlineCodes": [
            "AS"
        ],
        "travelerPricings": [
            {
                "travelerId": "1",
                "fareOption": "STANDARD",
                "travelerType": "ADULT",
                "price": {
                    "currency": "USD",
                    "total": "1446.23",
                    "base": "1324.63"
                },
                "fareDetailsBySegment": [
                    {
                        "segmentId": "1",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "2",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    },
                    {
                        "segmentId": "3",
                        "cabin": "BUSINESS",
                        "fareBasis": "KH0OASFN",
                        "brandedFare": "FR",
                        "brandedFareLabel": "FIRST",
                        "class": "C",
                        "includedCheckedBags": {
                            "quantity": 2
                        },
                        "amenities": [
                            {
                                "description": "SEAT ASSIGNMENT",
                                "isChargeable": false,
                                "amenityType": "PRE_RESERVED_SEAT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "MEAL 1",
                                "isChargeable": false,
                                "amenityType": "MEAL",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "PRIORITY BOARDING",
                                "isChargeable": false,
                                "amenityType": "TRAVEL_SERVICES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "110V AC POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "USB POWER",
                                "isChargeable": false,
                                "amenityType": "ENTERTAINMENT",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            },
                            {
                                "description": "CHANGEABLE TICKET",
                                "isChargeable": false,
                                "amenityType": "BRANDED_FARES",
                                "amenityProvider": {
                                    "name": "BrandedFare"
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
    */
    let {itineraries} = offer
    if(!itineraries){
        itineraries = []
    }
    let itn = itineraries[0]
    let segStart = itn.segments[0] 
    let sum_org = segStart.departure.iataCode
    let n = itn.segments.length
    let segEnd = itn.segments[n-1]
    let sum_departure = segStart.departure.at
    
   
    let sum_arrival = segEnd.arrival.at
    let sum_dst = segEnd.arrival.iataCode
    let sum_stops = n -1
    let sum_duration = itn.duration

    let sum_duration_dis = this.fltTime(sum_duration)

    
   
    let sum_departure_daytime = 'AM'
    let sum_arrival_daytime = 'PM'
    let sum_airlines = segStart.carrierCode
    let flight_airline_num_stops = itn ? itn.segments.length -1  :3
    let ds = null,dd =null
    let md =null, ms= null
    let diffms = null
    let layover = 22, lh =0, lmt=0, lm = 0
    let lds = '', lcity =''
    let airlinesName = ''
    if(!amap){
        amap={
            "B6":{
                "name" : "JetBlue Airways",
                "IATA" : "B6"
            },
            "UA":{
                "name" : "United Airlines",
                "IATA" : "UA"
            }
        }
    }
     if(amap && amap[sum_airlines]){
        airlinesName = amap[sum_airlines].name
     }
/*

*/
    if(flight_airline_num_stops == 0){
    
        //segStart.arrival.iataCode
        /*
        ds =itn.segments[0].arrival.at
        lcity = itn.segments[0].arrival.iataCode
        dd = itn.segments[1].departure.at
        ms = moment(ds)
        md = moment(dd)
         diffms = md.diff(ms)
         //layover = moment.duration(diffms).asMinutes()
         lmt = moment.duration(diffms).asMinutes()
         layover = moment.duration(diffms).asHours()
         lh = Math.floor(layover) 
         lm = lmt - (lh * 60)
         lds = `${lh} Hr ${lm} min in ${lcity}`
         */
       
        this.mp['x0']= `Destination`
    }else if(flight_airline_num_stops == 1){
        lds = this.layoverDis(itn,0,1)
        this.mp['x0']= lds
        this.mp['x1']= `Destination`
    }else if(flight_airline_num_stops == 2){  
        lds = this.layoverDis(itn,0,1)
        this.mp['x0']= lds
        lds = this.layoverDis(itn,1,2)
        this.mp['x1']= lds
        this.mp['x2']= `Destination`
    }else if(flight_airline_num_stops == 3){  
        lds = this.layoverDis(itn,0,1)
        this.mp['x0']= lds
        lds = this.layoverDis(itn,1,2)
        this.mp['x1']= lds
        lds = this.layoverDis(itn,2,3)
        this.mp['x2']= lds
        this.mp['x3']= `Destination`
    }else if(flight_airline_num_stops > 3){  
        let cn = 0
        let ce = cn + 1
        for(let p=0; p <flight_airline_num_stops; p++ ){
            lds = this.layoverDis(itn,cn,ce)
            this.mp['x'+cn]= lds
            cn = cn + 1
            ce = ce + 1
        }
        
       
        this.mp['x' + flight_airline_num_stops ]= `Destination`
    
    }else{
        diffms = 0
    }
    /*
       const  itn = {
        "duration": "PT46H34M",
        "segments": [
            {
                "departure": {
                    "iataCode": "EWR",
                    "terminal": "B",
                    "at": "2024-11-01T19:59:00"
                },
                "arrival": {
                    "iataCode": "LAX",
                    "terminal": "6",
                    "at": "2024-11-01T23:10:00"
                },
                "carrierCode": "AS",
                "number": "287",
                "aircraft": {
                    "code": "7M9"
                },
                "operating": {
                    "carrierCode": "AS"
                },
                "duration": "PT6H11M",
                "id": "1",
                "numberOfStops": 0,
                "blacklistedInEU": false
            },
            {
                "departure": {
                    "iataCode": "LAX",
                    "terminal": "6",
                    "at": "2024-11-02T19:45:00"
                },
                "arrival": {
                    "iataCode": "ANC",
                    "terminal": "S",
                    "at": "2024-11-03T00:19:00"
                },
                "carrierCode": "AS",
                "number": "193",
                "aircraft": {
                    "code": "73H"
                },
                "operating": {
                    "carrierCode": "AS"
                },
                "duration": "PT5H34M",
                "id": "2",
                "numberOfStops": 0,
                "blacklistedInEU": false
            },
            {
                "departure": {
                    "iataCode": "ANC",
                    "terminal": "S",
                    "at": "2024-11-03T13:30:00"
                },
                "arrival": {
                    "iataCode": "ADQ",
                    "at": "2024-11-03T14:33:00"
                },
                "carrierCode": "AS",
                "number": "89",
                "aircraft": {
                    "code": "73H"
                },
                "operating": {
                    "carrierCode": "AS"
                },
                "duration": "PT1H3M",
                "id": "3",
                "numberOfStops": 0,
                "blacklistedInEU": false
            }
        ]
    } */
        const { expandIconPosition } = this.state;
        const ars = [];
        let svrstars = {
            "sv_rating_no": 5,
            "sv_rating":"Excellent",
            "color": "#e8a01899"
        }
        console.log('###############  npt needed this.props.svrlocation ****************')
       
        let customerId = -1
       

        //const {o} = priceInfo
        let o = {
            product_cost_amount : '1030',
            avg_stars_rating : 5,
            flight_space_key: "1@4@1@ADQ"
        }
        console.log('############### price ****************')
        console.log(o)
        let flight_owner_message = 'Delta operated by SV DBA Deltaz Connection'
        let fltight_name = ''
        
        if(svcustProfile && svcustProfile.customerId ){
            if(typeof(svcustProfile.customerId) == "string"){
                customerId = parseInt(svcustProfile.customerId )
            }else{
                customerId = svcustProfile.customerId
            }
            if(customerId > 0){
           console.log('myreservationSpace')
           }else{
            console.log('internet userSpace')
           }
        }

        return (

            <div className="o-container-flist">
            <div className="o-box-flist-b1">
                    <span className="o-span">
                       
                            
                                   
                                
                                <span>
                                <p className="m-para-text">
                                <span style={{fontSize: "14px"}} > <PtIcon  style={{ fontSize:'18px', color: 'rgb(55, 173, 219)' }} type="dashboard" theme="filled" /><text style={{color:'#cc8e3b', fontSze:'16px',  paddingLeft: "10px", paddingRight:'20px'}}>{this.hdrDayDis(sum_departure)}</text><PlIcon type="line" style={{ color: 'rgb(232, 144, 26)' }} /><text style={{color:'#cc8e3b', fontSze:'16px', paddingLeft: "20px"}} >{this.hdrDayDis(sum_arrival)}</text></span>
                                {svmcity ===false ? this.portDetails(dcityName,dstateCode,dcountryCode, sum_org, ocityName,ostateCode,ocountryCode,sum_dst):this.portMDetails(sum_org,sum_dst,pmap)}
                                
                                {/* 
                                 <span style={{fontSize: "14px"}} className="d-block" >   <text style={{fontSize:'14px', color:'rgb(61, 10, 204)'}} className="svr-hotel-room " >{ocityName}, {ostateCode},{ocountryCode} ({sum_org})  </text><PcIcon  style={{ fontSize:'18px', color: 'rgb(61, 10, 204)' }} type="export"  /> <text style={{fontSize:'14px', color: 'rgb(61, 10, 204)'}} className="svr-hotel-room" >{dcityName}, {dstateCode}, {dcountryCode} ({sum_dst}) </text> </span>
                                 
                                */}
                                   
                                    <span style={{fontSize: "14px"}} > <PcnIcon  style={{ color: '#ca61a1', opacity:'0.9', fontSize:'16px' }} type="account-book" theme="filled" /><text style={{paddingLeft: "10px", color:'#898995'}}>{airlinesName}, Operated By {sum_airlines}</text></span>
            
                                   </p>
                                </span>
                            
                        
            
                       
                    </span>
                </div>
                <div className="o-box-flist-b2">
                    <span className="o-span">
                        
                                <p className="m-para-text">
                                <span style={{fontSize: "14px"}} > <text style={{fontSize:'14px',color:'#768999'}} >{sum_duration_dis}</text><PstopIcon style={{paddingLeft: "10px", color: 'rgb(27, 181, 227)' , fontSize:'14px'}}   /><text style={{fontSize:'14px',color:'#768999',paddingLeft: "10px"}} >{flight_airline_num_stops} Stop</text></span>
                                    <text style={{fontSize:'14px'}} className="svr-hotel-room d-block"> {lds} </text>
                                    <text style={{fontSize:'12px',color:'#898995'}} className="f12  d-block"> {sum_airlines} </text>
                                </p>
                            
                    </span>
                </div>
                <div className="o-box-flist">
                    <span className="o-span">
                       
                            
                           
                                <p className="m-para-text">
                                
                                    <text style={{fontSize:'18px'}} className="svr-hotel-price d-block">Total: {offer.price.currency == 'USD' ? '$': offer.price.currency}{offer.price.total} </text>
                                    <text style={{fontSize:'14px'}} className="svr-hotel-stay d-block">Base: {offer.price.currency == 'USD' ? '$': offer.price.currency}{offer.price.base}</text>
                                    <span style={{fontSize: "12px"}} > <Icon style={{ color: '#122196' }} type="gift"  /><text style={{paddingLeft: "10px",  fonrSize:'13px', color:'#898995'}}>Save $2.67 SVPromoClub </text></span>
                                    {this.getFSKReserveHtmlButton(o,svcustProfile)
                                              
                                            }
                                        {/* 
                                    <Button style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svflysearch/svredfly/${o.flight_space_key}`}>Reserve  </Link></Button>
                                            */}
                                </p>
                            
                        
                    </span>
                </div>
                
                <Collapse bordered={false} defaultActiveKey={['1']} expandIconPosition={expandIconPosition} onChange={this.callbackAc}>
                    {
                        itn.segments.map( (seg,idx)=>{
                            return ( 
                            <Panel header={this.getPanelHdr(seg)} key={idx}>
                                 {this.getPanelBody(seg,idx)}
                    
                                </Panel>)
                        })
                    }
                   
   
  </Collapse>
               
            </div>
          
        )
    }

//newfunc
depDis = (seg) => {
    let ds =seg.departure.at
   
    let ms = moment(ds)
    let dis = ms.format("ddd, MMM Do YYYY, h:mm:ss a")
    return dis
}
timeDis = (ds) => {
    // let ds =seg.departure.at
    
     let ms = moment(ds)
     let dis = ms.format(" h:mm a")
     return dis
 }
dayDis = (ds) => {
    // let ds =seg.departure.at
    
     let ms = moment(ds)
     let dis = ms.format("ddd, MMM Do YYYY")
     return dis
 }
hdrDayDis = (ds) => {
    /*
moment(input).format("MMMM DD YYYY, HH:mm:ss");
const moment = require("moment");

const input = "2026-06-11T23:41:00";

const result = moment.parseZone(input)
  .format("dddd, MMMM DD YYYY, hh:mm:ss A");

console.log(result);
    */
   /*
    let ms = moment(ds)
    let dis = ms.format("ddd, MMM YY h:mm a")
    */
    console.log('got ds **', ds)
    const dis = moment.parseZone(ds).format("ddd, MMM DD,YYYY, hh:mm A")
    

    console.log('showing dis **', dis)
  
    return dis

 }
 
 detDis = (ds) => {
    /*
    let ms = moment(ds)
    let dis = ms.format("ddd, h:mm a")
    */
    const dback = moment.parseZone(ds).format("ddd, MMM DD,YYYY, hh:mm A")
    
    return dback

 }
layoverDis =(itn, idxStart, idxEnd)=>{
    let ds = null,dd =null
    let md =null, ms= null
    let diffms = null
    let layover = 22, lh =0, lmt=0, lm = 0
    let lds = '', lcity =''


    //segStart.arrival.iataCode
    ds =itn.segments[idxStart].arrival.at
    lcity = itn.segments[idxStart].arrival.iataCode
    dd = itn.segments[idxEnd].departure.at
    ms = moment(ds)
    md = moment(dd)
    diffms = md.diff(ms)
     //layover = moment.duration(diffms).asMinutes()
     lmt = moment.duration(diffms).asMinutes()
     layover = moment.duration(diffms).asHours()
     lh = Math.floor(layover) 
     lm = lmt - (lh * 60)
     lds = `${lh} Hr ${lm} min in ${lcity}`

    return lds
}

}


export default AmbLocationSVPriceListView